import React from "react";
import { Avatar } from "@toddle-edu/ds-web";

const DefaultPlannerIcon = props => {
  const { backgroundColor, label } = props;

  return (
    <Avatar
      name={label}
      size="medium"
      shape="square"
      theme="light"
      color={backgroundColor}
      dsVersion="2.0"
    />
  );
};

export default DefaultPlannerIcon;
DefaultPlannerIcon.displayName = "DefaultPlannerIcon";
